import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("revive_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default http;

// Public
export const getAppliances = () => http.get("/appliances").then((r) => r.data);
export const getServices = (appliance) => http.get("/services", { params: { appliance } }).then((r) => r.data);
export const getAllServices = () => http.get("/services").then((r) => r.data);
export const getPrices = () => http.get("/prices").then((r) => r.data);
export const getPincodes = () => http.get("/pincodes").then((r) => r.data);
export const checkPincode = (pincode) => http.post("/pincode/check", { pincode }).then((r) => r.data);
export const getTestimonials = () => http.get("/testimonials").then((r) => r.data);
export const getFaqs = () => http.get("/faqs").then((r) => r.data);
export const createBooking = (payload) => http.post("/bookings", payload).then((r) => r.data);

// Admin
export const adminLogin = (username, password) => http.post("/admin/login", { username, password }).then((r) => r.data);
export const adminMe = () => http.get("/admin/me").then((r) => r.data);
export const adminStats = () => http.get("/admin/stats").then((r) => r.data);
export const adminBookings = (status) => http.get("/admin/bookings", { params: status ? { status } : {} }).then((r) => r.data);
export const adminUpdateBooking = (id, data) => http.patch(`/admin/bookings/${id}`, data).then((r) => r.data);
export const adminListPin = () => http.get("/admin/pincodes").then((r) => r.data);
export const adminCreatePin = (data) => http.post("/admin/pincodes", data).then((r) => r.data);
export const adminUpdatePin = (id, data) => http.patch(`/admin/pincodes/${id}`, data).then((r) => r.data);
export const adminDeletePin = (id) => http.delete(`/admin/pincodes/${id}`).then((r) => r.data);
export const adminListTestimonials = () => http.get("/admin/testimonials").then((r) => r.data);
export const adminCreateTestimonial = (data) => http.post("/admin/testimonials", data).then((r) => r.data);
export const adminUpdateTestimonial = (id, data) => http.patch(`/admin/testimonials/${id}`, data).then((r) => r.data);
export const adminDeleteTestimonial = (id) => http.delete(`/admin/testimonials/${id}`).then((r) => r.data);
export const adminCreateFaq = (data) => http.post("/admin/faqs", data).then((r) => r.data);
export const adminUpdateFaq = (id, data) => http.patch(`/admin/faqs/${id}`, data).then((r) => r.data);
export const adminDeleteFaq = (id) => http.delete(`/admin/faqs/${id}`).then((r) => r.data);
export const adminCreatePrice = (data) => http.post("/admin/prices", data).then((r) => r.data);
export const adminUpdatePrice = (id, data) => http.patch(`/admin/prices/${id}`, data).then((r) => r.data);
export const adminDeletePrice = (id) => http.delete(`/admin/prices/${id}`).then((r) => r.data);
export const adminCustomers = () => http.get("/admin/customers").then((r) => r.data);
export const adminGetSettings = () => http.get("/admin/settings").then((r) => r.data);
export const adminSaveSettings = (data) => http.post("/admin/settings", data).then((r) => r.data);
export const getPaymentConfig = () => http.get("/payment-config").then((r) => r.data);
export const createPaymentOrder = (data) => http.post("/payments/create-order", data).then((r) => r.data);
export const verifyPayment = (data) => http.post("/payments/verify", data).then((r) => r.data);
